export default (value: string | null) => {
  if (isNaN(Number(value)) || Number(value) < 0) {
    return "Value must be a positive number"
  }
  return true
}
